import { useState } from "react";
import { Gem, Mic, Loader2, Landmark } from "lucide-react";
import { startProCheckout } from "../lib/premium";
import { openTransfer } from "../lib/transfer";

export default function PremiumUpsell({ feature = "el dictado con IA" }) {
  const [busy, setBusy] = useState(false);
  const go = async () => { setBusy(true); await startProCheckout(); };
  return (
    <div data-testid="premium-upsell" className="rounded-2xl border border-brand-terracotta/25 bg-gradient-to-br from-brand-terracotta/[0.06] to-brand-sand/20 p-4">
      <div className="flex items-start gap-3">
        <div className="w-10 h-10 rounded-xl bg-brand-terracotta/15 text-brand-terracotta flex items-center justify-center shrink-0"><Gem size={20} /></div>
        <div className="flex-1 min-w-0">
          <p className="font-outfit font-bold text-brand-ink text-sm">Función Premium — Plan Pro</p>
          <p className="text-xs text-muted-foreground mt-0.5">{`Activa ${feature}: graba la consulta y la IA transcribe y arma la historia clínica por apartados. Incluye Oci por voz.`}</p>
          <button data-testid="premium-upgrade-btn" onClick={go} disabled={busy}
            className="mt-3 inline-flex items-center gap-1.5 bg-brand-terracotta hover:bg-brand-terracottaDark text-white text-xs font-bold px-4 py-2 rounded-xl transition-all disabled:opacity-60">
            {busy ? <Loader2 size={14} className="animate-spin" /> : <Mic size={14} />} Actualizar a Plan Pro ($400 MXN/mes)
          </button>
          <button data-testid="premium-transfer-link" onClick={() => openTransfer("pro")}
            className="mt-2 flex items-center gap-1.5 text-[11px] font-semibold text-brand-sageDark hover:underline">
            <Landmark size={12} /> ¿Problemas con la tarjeta? Paga por transferencia
          </button>
        </div>
      </div>
    </div>
  );
}
